module.exports = __webpack_public_path__ + "static/media/springville_club_house_thumb1.734ab9f0.webp";